import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="installment-final"
export default class extends Controller {
  static targets = ["form","startDate","endDate","countedRates","amountPerRate","totalAmount","interestAmount","inputInvoiceDate","inputAmount","inputSelCountMonth","inputDateFirstRate","inputDateLastInstallment","inputFinalAmount","inputAmountRate","formInputTreatmentNumber"]

  connect() {
  }

  show(form_data){
    this.element.classList.remove("displayNone")
    this.startDateTarget.innerHTML = form_data.calculation.start_date
    this.endDateTarget.innerHTML = form_data.calculation.end_date
    this.countedRatesTarget.innerHTML = form_data.calculation.counted_rates
    this.amountPerRateTarget.innerHTML = form_data.calculation.amount_per_rate
    this.totalAmountTarget.innerHTML = form_data.calculation.total_amount
    this.interestAmountTarget.innerHTML = form_data.calculation.interest_amount

    this.inputInvoiceDateTarget.value = form_data.calculation.invoice_date
    this.inputAmountTarget.value = form_data.calculation.invoice_amount
    this.inputSelCountMonthTarget.value = form_data.calculation.counted_rates
    this.inputDateFirstRateTarget.value = form_data.calculation.start_date
    this.inputDateLastInstallmentTarget.value = form_data.calculation.end_date
    this.inputFinalAmountTarget.value = form_data.calculation.total_amount
    this.inputAmountRateTarget.value = form_data.calculation.amount_per_rate

    this.formInputTreatmentNumberTarget.value = form_data.treatmentNumber
  }

  submit(event){
    event.preventDefault();
    if(!this.formTarget.checkValidity()){
      this.formTarget.classList.add("was-validated")
    }else{
      this.formTarget.submit()
    }
  }
}
